const formatName = (name) => name.replace(/\W+/g, ' ').split(/ |\B(?=[A-Z])/).map(word => word.toLowerCase()).join('');
const createElement = (container, type, attrs = {}) => {
    const el = document.createElement(type);
    Object.keys(attrs).forEach(key => el.setAttribute(key, attrs[key]));
    container.appendChild(el);
    return el;
};

export { createElement, formatName };
